export default __webpack_public_path__ + "static/media/referencia.2e6d16dd.svg";